import { useEffect, useState } from 'react';

// Returns the usable inner dimensions of a widget by subtracting padding, header height, and an optional offset.
// For use in content that should fit without overflow; scrollbars will appear if content exceeds this area.
export const useWidgetInnerSize = (ref, theme) => {
  const [size, setSize] = useState({ width: 0, height: 0, header: 0 });

  useEffect(() => {
    const element = ref?.current;
    if (!element) return;

    const updateSize = () => {
      const header = element.querySelector('.widget-header');
      if (!header) return;

      const widgetWidth = element.offsetWidth;
      const widgetHeight = element.offsetHeight;
      const headerHeight = header.offsetHeight;
      const margin = (theme.params?.padding || 10) * 2;

      setSize({
        width: widgetWidth - margin,
        height: widgetHeight - headerHeight - margin - 10,
        header: headerHeight
      });
    };

    const debouncedUpdateSize = _.debounce(updateSize, 200);

    // Widget header may be lazily loaded
    const mutationObserver = new MutationObserver(() => {
      const header = element.querySelector('.widget-header');
      if (header) {
        mutationObserver.disconnect();
        debouncedUpdateSize();
      }
    });

    mutationObserver.observe(element, { childList: true, subtree: true });

    const resizeObserver = new ResizeObserver(debouncedUpdateSize);
    resizeObserver.observe(element);

    debouncedUpdateSize();

    return () => {
      mutationObserver.disconnect();
      resizeObserver.disconnect();
    };
  }, [ref, theme]);

  return size;
};